import "./Home.css";

export default function Home(){
return(
  <div className="all-sections home-wrapper" id="home">
    <h1 className="welcome-text">Welcome to the<br></br>destiny of<br></br><span className="welcome-text-bolder">DESIGN</span></h1>
  </div>
)

}